import { Box, Typography, useTheme } from '@mui/material';

export const Subtitle = ({
  text,
  icon,
}: {
  icon: React.ReactNode;
  text: string;
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mt: 1,
        mb: 1.5,
      }}
    >
      {icon}
      <Typography
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontSize: theme.fontSizes.body,
          fontWeight: 700,
          color: theme.palette.primary.main,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};
